export default "__VITE_ASSET__CRP0HJOh__"